module.exports = __webpack_public_path__ + "static/Wix-0fcac6e29ea1f7c0dd723c82a2ee73e5.svg";